import { BrandDiscount } from "../../models/responses/brandDiscount";

export const handleFloatToInt = (value: number): string => {
  return parseInt(value.toFixed(2).replace(".", "")).toString();
};

export const parseAndCalculateFromPercentage = (
  guideprice: string,
  value: string
): string => {
  value = value.replace(",", ".");
  if (value.startsWith("0") && !value.includes(".")) value = value.substring(1);
  if (value.includes("%")) {
    value = calculateFromPercentage(guideprice, value).toString();
  }
  if (isNaN(parseFloat(value))) value = "0";
  return value;
};

export const calculateFromPercentage = (
  guideprice: string,
  percentage: string
): number => {
  let result =
    parseFloat(guideprice) -
    (parseFloat(percentage.replace("%", "")) * parseFloat(guideprice)) / 100;
  if (!result || isNaN(result)) return 0;
  return result;
};

export const interpretAsDecimal = (input: number | null | undefined): number => {
  if (input === null || input === undefined) return 0;
  var value = input.toString();
  var beforeComma = value.slice(0, value.length - 2);
  var afterComma = value.slice(value.length - 2, value.length);

  return parseFloat(`${beforeComma}.${afterComma}`);
};

export const calculateWorkshopPriceFromSalesPrice = (
  salesPrice: string,
  brandDiscount: BrandDiscount
): number => {
  if (
    brandDiscount.workshopSalesDiscount === undefined ||
    brandDiscount.workshopSalesDiscount === "0" ||
    brandDiscount.workshopSalesDiscount === "NaN"
  ) {
    return asTwoDecimals(parseFloat(salesPrice));
  }

  return asTwoDecimals(
    parseFloat(salesPrice) *
      asCalculatedPercentage(brandDiscount.workshopSalesDiscount)
  );
};

export const calculateStoreSalesPriceFromSalesPrice = (
  salesPrice: string,
  brandDiscount: BrandDiscount
): number => {
  if (
    brandDiscount.storeDiscount === undefined ||
    brandDiscount.storeDiscount === "0" ||
    brandDiscount.storeDiscount === "NaN"
  ) {
    return asTwoDecimals(parseFloat(salesPrice));
  }

  return asTwoDecimals(
    parseFloat(salesPrice) * asCalculatedPercentage(brandDiscount.storeDiscount)
  );
};

export const asCalculatedPercentage = (value: string): number => {
  return (100 - parseFloat(value)) / 100;
};

export const asTwoDecimals = (value: number): number => {
  return Math.floor(value * 100) / 100;
};
